// extracted by mini-css-extract-plugin
export default {"label":"style_label__EpNo9","tooltipIcon":"style_tooltipIcon__PFwlw"};